import { UsdCell } from '@siliconx/shared/ui/UsdCell';

/**
 * D8: a server with no System FMV contributes the sum of its priced
 * components to portfolio value. That number is an estimate, so it is
 * labelled wherever it is shown.
 */
export function FmvCell({
  value,
  estimatedFromComponents,
  withheldReason,
}: {
  value: number | null;
  estimatedFromComponents: boolean;
  /** SIL-2504: the SKU match is inferred, so no FMV is shown. */
  withheldReason?: 'sku_match_unverified' | null;
}) {
  if (value === null && withheldReason === 'sku_match_unverified') {
    return (
      <span
        className="inline-flex rounded bg-amber-50 px-1.5 py-0.5 text-xs font-medium text-amber-800"
        title="Awaiting verification by SiliconX"
      >
        Unverified SKU match - FMV withheld
      </span>
    );
  }
  return (
    <span className="inline-flex flex-col items-end">
      <UsdCell value={value} />
      {estimatedFromComponents && value !== null && (
        <span
          className="text-xs text-zinc-500"
          title="This server has no System FMV yet. The value is the sum of its priced components."
        >
          est. from components
        </span>
      )}
    </span>
  );
}
